import { To } from 'react-router-dom';

import { ClickActions } from '@core/push-notifications-service';
import { ROUTES } from '@core/routes';

export const PushNotificationRouteMapper: Record<ClickActions, To | null> = {
  [ClickActions.Careplans]: ROUTES.dashboard.home,
  [ClickActions.CaretaskAnswerError]: ROUTES.dashboard.home,
  [ClickActions.Medications]: ROUTES.dashboard.medication,
  [ClickActions.Appointments]: ROUTES.dashboard.appointment,
  [ClickActions.StartChat]: ROUTES.dashboard.careTeams.details.chat,
  [ClickActions.PdfReport]: ROUTES.dashboard.files.index,
  [ClickActions.VideoCalling]: null,
  [ClickActions.PrivacyPolicyUpdate]: null,
};
